import React from "react";
import { Controller, useForm } from "react-hook-form";
import { useState } from "react";
import Input from "../../input";
import { Control, FieldValues, UseFormWatch } from "react-hook-form";
import Card from "../../card";
import Icon from "../../../assets/icons";
import PasswordCriteria from "../../password-criteria";
import Button from "../../button";
import { CircleLoader } from "react-spinners";
interface PasswordProps {
  createUser: (e: React.FormEvent<HTMLFormElement>) => void;
  control: Control<FieldValues>;
  loading: boolean;
  watch: UseFormWatch<FieldValues>;
}

const CreatePassword = ({
  createUser,
  control,
  loading,
  watch,
}: PasswordProps) => {
  const [viewPassword, setViewPassword] = useState(false);
  const password = watch("password", "");

  const rememberMeJSON = localStorage.getItem("rememberMe");
  const rememberMe = rememberMeJSON ? JSON.parse(rememberMeJSON) : null;
  const [rememberMeClicked, setRememberMeClicked] = useState(
    rememberMe ? true : false
  );

  const handleShowPassword = () => {
    setViewPassword((previousValue): boolean => !previousValue);
  };

  const handleMouseDownPassword = (
    event: React.MouseEvent<HTMLButtonElement>
  ) => {
    event.preventDefault();
  };

  return (
    <Card
      title="Create Password"
      subtitle="Create a secure password to access your account"
    >
      <form className="mt-6 md:mt-8" onSubmit={createUser}>
        <div className="flex flex-col gap-4 md:gap-6 mb-5">
          <div className="w-full">
            <Controller
              name="password"
              control={control}
              rules={{
                required: "Password is required",
              }}
              render={({ field, fieldState }) => (
                <div className="w-full relative">
                  <Input
                    label="Password"
                    type={viewPassword ? "text" : "password"}
                    value={field.value}
                    className="w-full"
                    onChange={field.onChange}
                    autoComplete="off"
                    icon="passwordIcon"
                  />
                  <button
                    onClick={handleShowPassword}
                    onMouseDown={handleMouseDownPassword}
                    className="w-5 h-5 absolute top-1/2 right-2 transform -translate-y-1/2 mt-4"
                    type="button"
                  >
                    <Icon
                      name={!viewPassword ? "eyecloseicon" : "eyeopenicon"}
                    />
                  </button>
                  {fieldState?.error && (
                    <p className="absolute bottom-[-18px] left-0 text-red-500 text-xs">
                      {fieldState.error.message}
                    </p>
                  )}
                </div>
              )}
            />
          </div>
          <PasswordCriteria password={password} />
        </div>
        <div className="flex justify-center items-center mt-5">
          <Button
            size="lg"
            variant="primary"
            type="submit"
            className="font-normal"
          >
            {loading ? (
              <CircleLoader color="#ffffff" loading={loading} size={20} />
            ) : (
              <div className="flex gap-3">
                Sign in <Icon name="signIcon" />
              </div>
            )}
          </Button>
        </div>
      </form>
    </Card>
  );
};

export default CreatePassword;
